(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ss-country-selector"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit',event=>{const form=event.target;if(form.id!=='ss-footer-country')return;const spanish=['ES','AR','BO','CL','CO','CR','EC','SV','GT','GQ','HN','MX','NI','PA','PY','PE','DO','UY','VE'];form.elements.language_code.value=spanish.includes(form.elements.country_code.value)?'es':'en';});
  } catch(e) { console.error(e); }
})();

})();
